module.exports = __webpack_public_path__ + "assets/img/newQuestionfinish@2x.ed349740.png";